/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S5_Li3_DescInputs */

const tr_iade_iptal_s5_li3_desc = /** @type {(inputs: Iade_Iptal_S5_Li3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüketilmiş krediler, AI istek sayıları ve SMS/e-posta gönderimleri iadeye konu edilemez.`)
};

const en_iade_iptal_s5_li3_desc = /** @type {(inputs: Iade_Iptal_S5_Li3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consumed credits, AI request counts and SMS/email deliveries cannot be subject to a refund.`)
};

const de_iade_iptal_s5_li3_desc = /** @type {(inputs: Iade_Iptal_S5_Li3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbrauchte Credits, AI Anfragen sowie versendete SMS und E-Mails können nicht Gegenstand einer Erstattung sein.`)
};

const ru_iade_iptal_s5_li3_desc = /** @type {(inputs: Iade_Iptal_S5_Li3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Израсходованные кредиты, количество запросов AI и отправленные SMS и электронные письма не могут являться предметом возврата.`)
};

/**
* | output |
* | --- |
* | "Consumed credits, AI request counts and SMS/email deliveries cannot be subject to a refund." |
*
* @param {Iade_Iptal_S5_Li3_DescInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s5_li3_desc = /** @type {((inputs?: Iade_Iptal_S5_Li3_DescInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S5_Li3_DescInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s5_li3_desc(inputs)
	if (locale === "de") return de_iade_iptal_s5_li3_desc(inputs)
	if (locale === "ru") return ru_iade_iptal_s5_li3_desc(inputs)
	return tr_iade_iptal_s5_li3_desc(inputs)
});